/* istanbul ignore file */
import React from 'react';
import Page from 'components/Page/index';
import { useNavigate } from 'react-router-dom';
import { NotFoundContainer, Heading, BackHomeButton } from 'pages/Summary/styles';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Page>
      <NotFoundContainer>
        <Heading>Oops! The page you are looking for does not exist.</Heading>
        <BackHomeButton onClick={() => navigate('/')}>Go Back to Home</BackHomeButton>
      </NotFoundContainer>
    </Page>
  );
};

export default NotFoundPage;
